export default __webpack_public_path__ + "static/media/zoomed_vertical_lighttodark.a40c598d.png";